import {
  type CreateContext,
  fontString,
  type MeasureText,
  REFERENCE_FONT_PX,
} from '@repo/design-renderer';
import type { Raster } from '@repo/warp-engine';

const context2d = (canvas: HTMLCanvasElement): CanvasRenderingContext2D => {
  const ctx = canvas.getContext('2d');
  if (ctx === null) throw new Error('캔버스 2D 컨텍스트를 만들 수 없습니다.');
  return ctx;
};

/** 래스터를 캔버스에 그린다. 캔버스 픽셀 크기를 래스터에 맞춘다. */
export const drawRasterToCanvas = (canvas: HTMLCanvasElement, raster: Raster): void => {
  canvas.width = raster.width;
  canvas.height = raster.height;
  const ctx = context2d(canvas);
  const imageData = ctx.createImageData(raster.width, raster.height);
  imageData.data.set(raster.data);
  ctx.putImageData(imageData, 0, 0);
};

/** 렌더러가 글리프를 그릴 임시 캔버스 컨텍스트(브라우저). */
export const createCanvasContext: CreateContext = (width, height) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return context2d(canvas);
};

/** 2D 컨텍스트가 없을 때의 글자당 추정 폭(em). */
const FALLBACK_EM_PER_CHAR = 0.5;

/**
 * 100px 기준 글자 폭 측정기(T5). 컨텍스트는 첫 측정 때 만들어 재사용한다.
 * 컨텍스트를 못 얻으면 던지지 않고 글자 수 기반 추정 폭을 돌려준다.
 */
export const createCanvasMeasure = (): MeasureText => {
  let ctx: CanvasRenderingContext2D | null | undefined;
  return (text, familyName) => {
    if (ctx === undefined) ctx = document.createElement('canvas').getContext('2d');
    if (ctx === null) return text.length * FALLBACK_EM_PER_CHAR * REFERENCE_FONT_PX;
    ctx.font = fontString(REFERENCE_FONT_PX, familyName);
    return ctx.measureText(text).width;
  };
};
